module.exports = __webpack_public_path__ + "img/abia-shield.d9c8bda4.png";